<template>
  <ElDialog
    class="modal"
    :visible.sync="showModal"
    :width="modalWidth">
    <h2 class="modal__title">
      Найдены совпадения по ГРЗ
    </h2>
    <div class="modal__body">
      <p class="modal__text" v-html="grzMessageList.join('<br>')">
      </p>
    </div>
    <div class="modal__submit-buttons">
      <BaseButton text="Закрыть окно"
                  size="large"
                  type="secondary"
                  plain
                  @click.native="closeModal"/>
    </div>
  </ElDialog>
</template>

<script>
import modal from "@/mixins/modal";
import BaseButton from '@/components/ui/BaseButton';

export default {
  name: 'ModalPolicyIssuanceGrz',
  components: {
    BaseButton
  },
  props: {
    grzMessageList: {
      type: Array,
      required: true
    }
  },
  mixins: [modal],
}
</script>